// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"footer_infoButton__1KYOh"};